import { ActionArgs } from '../../action/ActionArgs'
import { Field, Float, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import type { Order } from '../Order'

export interface ISplitOrder extends IAction<Order, SplitOrderArgs> {}

@InputType()
export class SplitOrderArgs extends ActionArgs {
  @Field(() => String)
  sourceOrderId: string

  @Field(() => String, { nullable: true })
  destinationOrderId?: string

  @Field(() => Float, { nullable: true })
  quantity?: number

  @Field(() => String)
  sourceItemId: string
}
